import { useState, useEffect } from "react";

type UseSessionStateReturn<T> = [
  sessionState: T | null,
  setSessionState: React.Dispatch<React.SetStateAction<T | null>>
];

function useSessionState<T>({
  sessionKey,
  initialValue,
}: {
  sessionKey: string;
  initialValue?: T | null;
}): UseSessionStateReturn<T> {
  const initialState = (initialValue ??
    sessionStorage.getItem(sessionKey) ??
    null) as T | null;

  const [sessionState, setSessionState] = useState<T | null>(initialState);

  useEffect(() => {
    if (sessionState === null) {
      sessionStorage.removeItem(sessionKey);
    } else {
      sessionStorage.setItem(sessionKey, sessionState as unknown as string);
    }
  }, [sessionState, sessionKey]);

  return [sessionState, setSessionState];
}

export default useSessionState;
